import type { APIDestination } from '../../../../../../../../typings/Destination.interface';
import { cleanseFormErrorObject } from '../../../../../utils/form';
import destination_configuration_form_props, {
  DeliveryGroupOverridesTable,
  DeliveryGroupsConfigurationFields,
  MAX_DELIVERY_GROUP_LENGTH,
  getDeliveryRateDefault,
  getDeliveryRateDefaultFromDestination,
  getDeliveryRateLimitWarning,
} from '../Forms/destination_configuration';
import type {
  DeliveryGroupOverrideFormValue,
  DeliveryGroupsFormState,
  DestinationConfigurationFormValues,
} from '../Forms/destination_configuration';

export type DeliveryGroupsFormValues = DestinationConfigurationFormValues;
export type { DeliveryGroupOverrideFormValue, DeliveryGroupsFormState };

export {
  DeliveryGroupOverridesTable,
  DeliveryGroupsConfigurationFields,
  MAX_DELIVERY_GROUP_LENGTH,
  getDeliveryRateDefault,
  getDeliveryRateDefaultFromDestination,
  getDeliveryRateLimitWarning,
};

export const getDeliveryGroupsInitialValues = (
  destination: APIDestination,
  max_events_per_second?: number | null,
): DeliveryGroupsFormValues =>
  destination_configuration_form_props.getInitialValues(
    destination,
    undefined,
    max_events_per_second,
  );

export const validateDeliveryGroups = async (
  values: DeliveryGroupsFormValues,
  supports_delivery_groups: boolean,
) =>
  cleanseFormErrorObject(
    await destination_configuration_form_props.validate(values, supports_delivery_groups),
  );

export const postprocessDeliveryGroupsValues = (
  values: DeliveryGroupsFormValues,
  supports_delivery_groups: boolean,
) => destination_configuration_form_props.postprocessValues(values, supports_delivery_groups);
